// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Admin__BidController from "./admin/bid_controller"
application.register("admin--bid", Admin__BidController)

import Admin__BidsFilterController from "./admin/bids_filter_controller"
application.register("admin--bids-filter", Admin__BidsFilterController)

import Admin__ChatAccountController from "./admin/chat_account_controller"
application.register("admin--chat-account", Admin__ChatAccountController)

import Admin__ChatMessageController from "./admin/chat_message_controller"
application.register("admin--chat-message", Admin__ChatMessageController)

import Admin__Stat__CatalogController from "./admin/stat/catalog_controller"
application.register("admin--stat--catalog", Admin__Stat__CatalogController)

import Admin__TaskController from "./admin/task_controller"
application.register("admin--task", Admin__TaskController)

import AutocompleteController from "./autocomplete_controller"
application.register("autocomplete", AutocompleteController)

import Bid__DateController from "./bid/date_controller"
application.register("bid--date", Bid__DateController)

import Catalog__CategorySwitcherController from "./catalog/category_switcher_controller"
application.register("catalog--category-switcher", Catalog__CategorySwitcherController)

import Catalog__CitiesInRegionAreasController from "./catalog/cities_in_region_areas_controller"
application.register("catalog--cities-in-region-areas", Catalog__CitiesInRegionAreasController)

import Catalog__InfiniteScrollController from "./catalog/infinite_scroll_controller"
application.register("catalog--infinite-scroll", Catalog__InfiniteScrollController)

import Catalog__LocalitySwitcherController from "./catalog/locality_switcher_controller"
application.register("catalog--locality-switcher", Catalog__LocalitySwitcherController)

import CategoryPlatesController from "./category_plates_controller"
application.register("category-plates", CategoryPlatesController)

import CenteringHorizontalScrollingController from "./centering_horizontal_scrolling_controller"
application.register("centering-horizontal-scrolling", CenteringHorizontalScrollingController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ContactPurchaseController from "./contact_purchase_controller"
application.register("contact-purchase", ContactPurchaseController)

import ContactRequestController from "./contact_request_controller"
application.register("contact-request", ContactRequestController)

import DestroyInTableRowController from "./destroy_in_table_row_controller"
application.register("destroy-in-table-row", DestroyInTableRowController)

import Form__AnonymousPhoneController from "./form/anonymous_phone_controller"
application.register("form--anonymous-phone", Form__AnonymousPhoneController)

import Form__AnonymousPhonesController from "./form/anonymous_phones_controller"
application.register("form--anonymous-phones", Form__AnonymousPhonesController)

import Form__AppendableSuggestionsController from "./form/appendable_suggestions_controller"
application.register("form--appendable-suggestions", Form__AppendableSuggestionsController)

import Form__CategoryController from "./form/category_controller"
application.register("form--category", Form__CategoryController)

import Form__CheckLimitController from "./form/check_limit_controller"
application.register("form--check-limit", Form__CheckLimitController)

import Form__EavValuesController from "./form/eav_values_controller"
application.register("form--eav-values", Form__EavValuesController)

import Form__LimitedLengthController from "./form/limited_length_controller"
application.register("form--limited-length", Form__LimitedLengthController)

import Form__PhoneController from "./form/phone_controller"
application.register("form--phone", Form__PhoneController)

import Form__PhonesController from "./form/phones_controller"
application.register("form--phones", Form__PhonesController)

import Form__PhotosController from "./form/photos_controller"
application.register("form--photos", Form__PhotosController)

import Form__PlacementsController from "./form/placements_controller"
application.register("form--placements", Form__PlacementsController)

import Form__TitleSeoPrefixController from "./form/title_seo_prefix_controller"
application.register("form--title-seo-prefix", Form__TitleSeoPrefixController)

import LogoController from "./logo_controller"
application.register("logo", LogoController)

import MainSearchController from "./main_search_controller"
application.register("main-search", MainSearchController)

import ModalDialogController from "./modal_dialog_controller"
application.register("modal-dialog", ModalDialogController)

import PhoneMaskController from "./phone_mask_controller"
application.register("phone-mask", PhoneMaskController)

import PhoneOrEmailMaskController from "./phone_or_email_mask_controller"
application.register("phone-or-email-mask", PhoneOrEmailMaskController)

import Post__ContactBlockController from "./post/contact_block_controller"
application.register("post--contact-block", Post__ContactBlockController)

import SideBannersController from "./side_banners_controller"
application.register("side-banners", SideBannersController)

import SortingController from "./sorting_controller"
application.register("sorting", SortingController)

import StateSwitcherController from "./state_switcher_controller"
application.register("state-switcher", StateSwitcherController)

import TelegramAppController from "./telegram_app_controller"
application.register("telegram-app", TelegramAppController)

import UncoverController from "./uncover_controller"
application.register("uncover", UncoverController)
